<template>
  <div>
    <v-skeleton-loader
      :loading="loading"
      transition="fade-transition"
      :class="{ 'pa-2': loading }"
      :height="height || 200"
      type="card"
    >
      <v-card :class="{ 'mt-5': hasTitle }" scroll>
        <v-card
          v-if="hasTitle"
          class="px-6 py-3 font-weight-bold"
          style="top: -18px; left: 18px; width: calc(100% - 36px)"
          :color="titleColor"
          dark
        >
          <slot name="title"> {{ title }} </slot>
        </v-card>
        <v-card
          :class="{ 'pt-0': hasTitle }"
          :height="height"
          :max-height="maxHeight"
          class="pa-3 elevation-0"
          style="overflow-y: auto"
        >
          <slot />
        </v-card>
      </v-card>
    </v-skeleton-loader>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },

    titleColor: {
      type: String,
      default: 'primary darken-1'
    },

    loading: {
      type: Boolean,
      default: false
    },

    height: {
      type: [String, Number],
      default: undefined
    },

    maxHeight: {
      type: [String, Number],
      default: undefined
    }
  },

  computed: {
    hasTitle() {
      return this.title || this.$slots.title
    }
  }
}
</script>

<style lang="scss" scoped></style>
